import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const terminationForCauseFilterLabel = () => t({ message: 'Termination for cause', comment: 'Insights: Termination for cause filter' });
export function TerminationForCauseFilter() {
    return <BooleanFilter name="metadataDocumentTerminationForCause" label={terminationForCauseFilterLabel()}/>;
}
